import { render, staticRenderFns } from "./ThreatVulnListing.vue?vue&type=template&id=1add1264&scoped=true&"
import script from "./ThreatVulnListing.vue?vue&type=script&lang=js&"
export * from "./ThreatVulnListing.vue?vue&type=script&lang=js&"
import style0 from "./ThreatVulnListing.vue?vue&type=style&index=0&id=1add1264&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1add1264",
  null
  
)

export default component.exports